import { ROUTE_LOGIN } from '@klear/constants'
import { getAuthBaseUrl } from '@klear/runtime-env'
import { useDocumentTitle } from '@klear/ui/hooks/use-document-title'

const Unauthorized = () => {
  useDocumentTitle('Unauthorized')
  return (
    <div className="min-h-screen flex items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-foreground mb-4">Access Denied</h1>
        <p className="text-muted-foreground mb-8">You don&apos;t have permission to access this area.</p>
        <a
          href={`${getAuthBaseUrl()}/${ROUTE_LOGIN}`}
          className="inline-block bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
        >
          Return Home
        </a>
      </div>
    </div>
  )
}

export default Unauthorized
